import { AxiosInstance, AxiosResponse } from 'axios'

import { BacenCrmActionResponse, BacenInviteStatusResponse } from 'models/interface/bacen'

export const bacenClient = (httpInstance: AxiosInstance) => ({
  sendAuthorizationResponse: async (
    token: string,
    key: string,
    origin: string,
    authorized: boolean,
    ip: string,
    fingerprint: string
  ): Promise<AxiosResponse<BacenCrmActionResponse>> => {
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/bacen/`
    return await httpInstance.post(url, {
      token,
      key,
      origin,
      deviceip: ip,
      devicefingerprint: fingerprint,
      authorized
    })
  },
  getInvitationStatus: async (
    token: string,
    key: string,
    origin?: string
  ): Promise<AxiosResponse<BacenInviteStatusResponse>> =>
    await httpInstance.get('/api/bacen/status', {
      params: {
        token,
        key,
        origin
      }
    }),
  resendInvite: async (token: string, key: string, origin?: string): Promise<AxiosResponse<BacenCrmActionResponse>> =>
    await httpInstance.post('/api/bacen/resend', { token, key, origin })
})
